import "./CategorySelection.css"


function CategorySelection({ CategoryList, onClickFunction, showEffect, field }) {


    const selectCategory = (e, category) => {
        onClickFunction(field, category)
        showEffect(false)
    }

    return (
        <div className="category-card ">
            {CategoryList &&
                CategoryList.map((item, index) => {

                    return (
                        <div className="category-item" key={item.value}
                            onClick={(e) => {
                                selectCategory(e, item.value)
                            }}>{item.value}</div>
                    )

                }
                )}
        </div>
    )
}

export default CategorySelection;